// https://fanduel.atlassian.net/wiki/spaces/FAW/pages/310259157370/Amplitude+Casino+next.js+Web+Migration+-+State+Selector
// https://fanduel.atlassian.net/wiki/spaces/FAW/pages/311719792933/Canada+Casino+Amplitude+Specifications+-+Escape+Hatch+Tagging+Spec
import type { AmplitudeEventKeys } from '@/tracking/amplitude/amplitude-properties.types';
import { getEventPropsBuilder, toSnakeCase } from '../../utils';

export const getStateSelectorModalViewedProps = getEventPropsBuilder(() => {
    return {
        event: 'State Selector Modal Viewed',
        Module: 'state_selector'
    };
});

export const getStateSelectedProps = getEventPropsBuilder(() => {
    return {
        event: 'State Selected',
        Module: 'state_selector'
    };
});

export const getStateSelectorCtaClickedProps = getEventPropsBuilder(() => {
    return {
        event: 'State Selector CTA Clicked',
        Module: 'state_selector_cta_clicked',
        'Link Text': "i_don't_see_my_state"
    };
});

export const getRegionSwitchAccessClickedProps = getEventPropsBuilder(
    (linkText: string): Partial<AmplitudeEventKeys> => {
        return {
            event: 'Region Switch Access Clicked',
            Module: 'footer',
            'Link Text': toSnakeCase(linkText)
        };
    }
);

export const getRegionSelectedProps = getEventPropsBuilder((region: string): Partial<AmplitudeEventKeys> => {
    return {
        event: 'Region Selected',
        Module: 'region_selector',
        Region: region.toLowerCase()
    };
});
